import {
  Report,
  ReportType,
} from '@/shared/api/protocol-ts/model/dto_report_pb';

export const reportHasStudyIDAndNotPanowing =
  (studyID: string) => (report: Report) =>
    report.SourceStudyIDs.includes(studyID) &&
    report.Type !== ReportType.ReportType_Pano_Bitewings;
